import { Vector3 } from "../math/Vector3.js";
import { Quaternion } from "../math/Quaternion.js";
import { Deg2Rad, lonLatDegToDecart } from "../math/MathEx.js";
import { kAU } from "../astronomy/AstroConstants.js";
export class PlanetNavigator {
    id;
    geoLocation;
    planet;
    cache;
    constructor(planet, geoLocation) {
        this.geoLocation = geoLocation;
        this.id = this.makeId(geoLocation);
        this.planet = planet;
        this.cache = new Map();
    }
    getCacheKey(type, jd) {
        return `${type}:${this.id}:${jd}`;
    }
    updateGeoLocation(newGeoLocation) {
        this.geoLocation = newGeoLocation;
        this.id = this.makeId(newGeoLocation);
    }
    makeId({ latitude, longitude, altitude, }) {
        return `${latitude}:${longitude}:${altitude}`;
    }
    position(jd) {
        const cacheKey = this.getCacheKey("position", jd);
        const cached = this.cache.get(cacheKey);
        if (cached)
            return cached;
        const obsDist = this.GetDistanceFromCenter();
        const res = this.up(jd).multiplyByFloat(obsDist);
        this.cache.set(cacheKey, res);
        return res;
    }
    center(jd) {
        const cacheKey = this.getCacheKey("center", jd);
        const cached = this.cache.get(cacheKey);
        if (cached)
            return cached;
        const res = this.GetCenterVsopPosition(jd);
        this.cache.set(cacheKey, res);
        return res;
    }
    up(jd) {
        const cacheKey = this.getCacheKey("up", jd);
        const cached = this.cache.get(cacheKey);
        if (cached)
            return cached;
        const res = Vector3.MultiplyQuaternionByVector3(this.GetBaseObjectLocalRotation(jd), this.GetLocalDirection());
        this.cache.set(cacheKey, res);
        return res;
    }
    forward(jd) {
        const cacheKey = this.getCacheKey("forward", jd);
        const cached = this.cache.get(cacheKey);
        if (cached)
            return cached;
        const res = Vector3.MultiplyQuaternionByVector3(this.GetBaseObjectLocalRotation(jd), this.GetLocalForward());
        this.cache.set(cacheKey, res);
        return res;
    }
    planetLocalRotation(jd) {
        return this.GetBaseObjectLocalRotation(jd);
    }
    lookRotation(jd) {
        return Quaternion.LookRotation(this.forward(jd), this.up(jd));
    }
    // next methods moved from LocationObserver
    GetCenterVsopPosition(jd) {
        return this.planet._getPosition(jd, Vector3.Zero());
    }
    GetDistanceFromHorizon() {
        return (this.geoLocation.altitude / 1000) * kAU;
    }
    GetDistanceFromCenter() {
        return this.planet.radius + this.GetDistanceFromHorizon();
    }
    // private GetRotationEquatorialToVsop(jd: number): Quaternion {
    //     return this.planet.RotationEquatorialToVSOP(jd);
    // }
    GetBaseObjectLocalRotation(jd) {
        return this.planet.localRotation(jd);
    }
    GetLocalDirection() {
        //GetLocalUp
        return lonLatDegToDecart(this.geoLocation.longitude, this.geoLocation.latitude);
    }
    GetLocalForward() {
        const lon = this.geoLocation.longitude * Deg2Rad;
        const lat = this.geoLocation.latitude * Deg2Rad;
        const sinLat = Math.sin(lat);
        return new Vector3(-sinLat * Math.cos(lon), Math.cos(lat), -sinLat * Math.sin(lon));
    }
}
